import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getSubmissions = (params = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/submissions`, {
    headers: authHeaders(),
    params,
  });

export const getSubmissionsStatusSeeder = () =>
  axiosInstance.get(`${ADMIN_API_URL}/get/submissions-status-seeder`, {
    headers: authHeaders(),
  });

// submissionId is optional: when sent, each tool's `information` holds the data
// entered in that submission (and only that submission).
export const getToolsFromTemplate = (templateId, submissionId = null) =>
  axiosInstance.post(
    `${ADMIN_API_URL}/template/get/tools`,
    {
      ...(templateId ? { template_id: templateId } : {}),
      ...(submissionId ? { submission_id: submissionId } : {}),
    },
    { headers: authHeaders() },
  );

export const getAllTemplates = () =>
  axiosInstance.get(`${ADMIN_API_URL}/get-all-template`, {
    headers: authHeaders(),
  });

export const downloadFinalCompletedSubmissionRequest = (sub_id) =>
  axiosInstance.post(
    `${ADMIN_API_URL}/submissions/download/final-completed`,
    { sub_id },
    { headers: authHeaders() },
  );

export const downloadOriginFilesRequest = (subId) =>
  axiosInstance.get(
    `${ADMIN_API_URL}/submissions/origin-files/${subId}/download`,
    { headers: authHeaders() },
  );

export const getPartyData = (sub_id) =>
  axiosInstance.get(`${ADMIN_API_URL}/submissions/get/party_data`, {
    headers: authHeaders(),
    params: { sub_id },
  });

export const getAuditLog = (sub_id) =>
  axiosInstance.get(`${ADMIN_API_URL}/submissions/audit_log/${sub_id}`, {
    headers: authHeaders(),
  });

export const getEventLog = (sub_id) =>
  axiosInstance.get(`${ADMIN_API_URL}/submissions/event_log/${sub_id}`, {
    headers: authHeaders(),
  });

export const removeSubmission = (submissionId) =>
  axiosInstance.delete(`${ADMIN_API_URL}/submissions/${submissionId}`, {
    headers: authHeaders(),
  });

export const updateSubmissionRecipientsRequest = (payload) =>
  axiosInstance.post(`${ADMIN_API_URL}/submissions/recipient-update`, payload, {
    headers: authHeaders(),
  });

export const getVerificationMethods = () =>
  axiosInstance.get(`${ADMIN_API_URL}/verification_methods`, {
    headers: authHeaders(),
  });

export const updateSubmissionPartiesRequest = (payload) =>
  axiosInstance.post(`${ADMIN_API_URL}/submissions/party-update`, payload, {
    headers: authHeaders({
      "Content-Type": "multipart/form-data",
    }),
  });

export const triggerBrowserDownload = (url, fileName) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  link.remove();
};